import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import Dropdown from 'react-dropdown';
import {
    NONE,
    RANDOMIZE,
    ACCUMULATE,
} from 'constants/aux-event-types.js';

const OPTIONS = [
    {label: "None", value: NONE},
    {label: "Randomize", value: RANDOMIZE},
    {label: "Accumulate", value: ACCUMULATE},
];

const PARAM_OPTIONS = [
    {label: "Transpose", value: 'transpose'},
    {label: "Velocity", value: 'velocity'},
    {label: "Duration", value: 'duration'},
    {label: "Chop", value: 'chop'},
    {label: "Panning", value: 'panning'},
];

const CirklonAuxEvents = ({track}) => { 
    return (
        <div className="aux-events">
          <CirklonAuxEventType
            parameter={track.auxEventATypeParameter}
            name="Aux Event A"
            limit={track.auxEventALimitParameter}
            variableParameter={track.auxEventAVariableParameter}
            mode={track.auxEventAModeParameter}
            track={track}
          />
          <CirklonAuxEventType
            parameter={track.auxEventBTypeParameter}
            variableParameter={track.auxEventBVariableParameter}
            name="Aux Event B"
            auxEvent="B"
            limit={track.auxEventBLimitParameter}
            mode={track.auxEventBModeParameter}
            track={track}
          />
       </div>
    );
}


const CirklonAuxEventType = ({track, parameter, name, limit, mode, variableParameter}) => {
    let [type, setType] = useState(parameter.get());
    let [variable, setVariable] = useState(variableParameter.get());

    const onChangeType = useCallback(({value}) => {
        parameter.set(value);
        setType(value);
    }, [setType, parameter]);

    const onChangeVariable = useCallback(({value}) => {
        variableParameter.set(value);
        setVariable(value);
    }, [setVariable, parameter]);

    return (
        <div className="aux-event-type">
          <div className="event-type-label">{name}</div>
          <Dropdown
            options={OPTIONS}
            onChange={onChangeType}
            value={OPTIONS.find(x => x.value === type)}
          />
          <Dropdown
            options={PARAM_OPTIONS}
            onChange={onChangeVariable}
            value={PARAM_OPTIONS.find(x => x.value === variable)}
          />
          {type === ACCUMULATE ?
           <AccumulatorOptions type={type} track={track} limit={limit} mode={limit}/>: ''}
        </div>
    );
};

const AccumulatorOptions = ({limit, mode, track, type, parameter}) => {
    return (
        <div className="accumulator-options">
          <EffectParameterSlider
            isParameter={true}
            name="Limit"
            min={0}
            step={parameter === 'velocity' || parameter === 'duration' ? 0.1 : 1}
            max={parameter === 'transpose' ? 32 : parameter === 'chop' ? 16 :
                 parameter = 'duration' ? 32 : 1}
            parameter={limit}/>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CirklonAuxEvents);
